import React, { ReactNode, useState } from 'react';
import { IconType, TextInput } from 'ui-toolkit';
import { ClickToViewTableHeader } from './ClickToViewTableHeader';

export interface ITextTableHeaderProps {
  text: string;
  filter?: string;
  onFilterChange: (x?: string) => void;
  sortItem?: ReactNode;
}

export const TextTableHeader: React.FC<ITextTableHeaderProps> = ({ text, filter, onFilterChange, sortItem }) => {
  const [detailInput, setDetailInput] = useState<string | undefined>(filter);
  return (
    <ClickToViewTableHeader
      text={text}
      filterText={filter && `(${filter})`}
      filterComponent={
        <TextInput
          value={detailInput}
          onChange={(value) => setDetailInput(value || undefined)}
          prependIconType={IconType.Search}
          placeholder={'Search'}
        />
      }
      onFilterDone={() => onFilterChange(detailInput)}
      sortItem={sortItem}
    />
  );
};
